module.exports = __webpack_public_path__ + "img/part4-img2-1.07f5ec94.png";